import Api from "../../../api";
import useLoader from "../../../utils/useLoader";
import { useEffect, useState } from "react";
import useAccessToken from "../../../utils/useAccessToken";

import Tree from "rc-tree";
import Skeleton from "react-loading-skeleton";

function LogContentFilesDisplay() {
  const { organizationData } = useAccessToken();
  const { isLoading, setIsLoading } = useLoader();
  const [treeData, setTreeData] = useState([]);

  const getOrgFiles = async () => {
    setIsLoading(true);

    const response = await Api.CommissionsService.retrieveCarrierFilesTree(
      `orgs/${organizationData.id}/my_files`
    );

    if (!response.success) {
      setIsLoading(false);
      return;
    }

    setTreeData(response.data);
    setIsLoading(false);
  };

  const download = async (fileDir) => {
    setIsLoading(true);

    const response = await Api.FirebaseStorage.Documents.download(fileDir);
    if (!response.success) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  const renderTreeNodes = (data) =>
    data.map((item) => ({
      key: item.key,
      title: (
        <div className="tree-node-title-div">
          <div>{item.title}</div>
          <div>{item.isLeaf ? item.metadata.updated : ""}</div>
          <div>
            {item.isLeaf ? (
              <div
                onClick={() => download(item.fullPath)}
                className="download-button"
              >
                Download
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      ),
      children: item.children ? renderTreeNodes(item.children) : [],
      isLeaf: item.isLeaf,
    }));

  useEffect(() => {
    getOrgFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationData]);

  return (
    <div className="log-content-files-display">
      <h2>My Files</h2>
      {isLoading ? (
        <Skeleton count={5} />
      ) : treeData.length > 0 ? (
        <Tree
          className="tree"
          showLine
          checkStrictly
          selectable={false}
          showIcon
          treeData={renderTreeNodes(treeData)}
          autoExpandParent
        />
      ) : (
        <h3>No results found</h3>
      )}
    </div>
  );
}

function LogContent() {
  return (
    <>
      <h1>Processed Commission Files</h1>

      <LogContentFilesDisplay />
    </>
  );
}

export default LogContent;
